import { CheckIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { ICON_BASE } from '../../utils/training';
import purpleCheckIcon from '@/assets/images/svg/purple_check_icon.svg';

interface StepIconProps {
  status: string;
}

export function StepIcon({ status }: StepIconProps) {
  if (status === 'done') {
    return (
      <img
        src={purpleCheckIcon}
        alt='Done'
        className='mt-[-2px] size-[30px] shrink-0 object-contain'
      />
    );
  }
  if (status === 'active' || status === 'uploading') {
    return <div className={clsx(ICON_BASE, 'animate-spin border-gray-200 border-t-brand-300')} />;
  }
  if (status === 'skipped') {
    return (
      <div
        className={clsx(ICON_BASE, 'flex items-center justify-center border-gray-200 bg-gray-200')}
      >
        <CheckIcon className='size-[14px] text-gray-400' />
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div
        className={clsx(ICON_BASE, 'flex items-center justify-center border-red-100 bg-red-100')}
      >
        <span className='text-12 font-bold text-red-500'>!</span>
      </div>
    );
  }
  return <div className={clsx(ICON_BASE, 'border-gray-200')} />;
}
